// @ts-nocheck
/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2019-12-09 17:27:55
 */

import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './MysketchPicker.css';

import { SketchPicker } from 'react-color'

class MysketchPicker extends Component {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    visible: false,
    color: '',
    top: 0,
    left: 0
  }

  componentWillUpdate(nextProps) {
    const value = nextProps.value
    const color = this.state.color
    if (value !== color) {
      this.setState({
        color: value
      })
    }
  }
  componentDidMount () {
    this.setState({
      color: this.props.value
    })
  }

  toggle (e) {
    const bound = e.target.getBoundingClientRect()
    let left = 0
    if (bound.left + 180 > 1280) {
      left = -180
    }
    this.setState({
      visible: !this.state.visible,
      left: left
    })
  }

  handleClose () {
    this.setState({
      visible: false
    })
  }

  handleChange (color) {
    const onChange = this.props.onChange;
    const hex = color.hex;
    this.setState({ 
      color: hex 
    })
    typeof onChange === 'function' && onChange(hex);
  }

  render() {
    const { visible, color, top, left } = this.state;
    return (
      <div className={s.container}>
        <div className={s.block} onClick={this.toggle} style={{backgroundColor: color}}>颜色</div>
        { visible && 
          <div>
            <div className={s.packWrapper} style={{top, left}}> <SketchPicker presetColors={[
              '#5ea4ce',
              '#cd6c5b',
              '#71ca5c',
              '#ffd725',
              '#efedee',
              '#989898',
              '#fecc75'
            ]} color={color} onChange={this.handleChange} /> </div>
            <div className={s.mark} onClick={this.handleClose} />
          </div>
        }

      </div>

    )
  }
}

export default withStyles(s)(MysketchPicker);



// WEBPACK FOOTER //
// src/components/MysketchPicker/MysketchPicker.js